import { Component, OnInit, OnChanges, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';

import { UpdateSanctionInfoComponent } from 'app/entities/monitoring/actual/sanction/sanctioninfo/updatesanctioninfo/update-sanction-info.component';
import { Sanction } from 'app/shared/models/sanction.model';
import { SanctionService } from 'app/entities/monitoring/actual/sanction/sanction.service';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'sanction-info',
  providers: [SanctionService],
  templateUrl: './sanction-info.component.html',
  styleUrls: ['./sanction-info.component.css']
})

/**
 * Component to display the monitoring sanction for the entity.
 */
export class SanctionInfoComponent implements OnInit, OnChanges {
  @Input() entityIdDetails: EntityIdDetails;

  public id: number;

  dialogRef: MdDialogRef<any>;
  sanctionInfoData: string;
  // Here -1 value is taken to display the spinned until the data is loaded.
  sanctionInfoDataCount: number = -1;
  sanctionInfoLoaded = false;
  matchResolutions: ApplicationValue[];

  constructor(
    public dialog: MdDialog,
    public viewContainerRef: ViewContainerRef,
    private sanctionInfoService: SanctionService,
    private entityMonitoringService: EntityMonitoringService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private warmUpService: WarmUpService) { }

  ngOnInit() {
    this.ngOnChanges();
    this.setUpMatchResolutions(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.SANCTION_MATCH_RESOLUTION));
  }

  ngOnChanges() {
    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = this.entityIdDetails.entityId;
      this.getSanctionInfoDesc();
    }
  }

  // Get Monitoring Elaboration Text Description..
  getSanctionInfoDesc() {
    this.sanctionInfoLoaded = false;
    this.sanctionInfoData = "";
    this.entityMonitoringService.getSanctionHistory(this.id).subscribe(response => {
      const list = (response && response.suggestionList) || [];
      this.sanctionInfoDataCount = list.filter(r => this.isPositiveResolution(r && r.matchResolution)).length;
      this.sanctionInfoLoaded = true;
    }, _err => {
      this.sanctionInfoDataCount = 0;
      this.sanctionInfoLoaded = true;
    });
  }

  setUpMatchResolutions(dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(response => {
        this.warmUpService.setApplicationTypeInLS(response);
        this.matchResolutions = response.values;
        if (this.id) {
          this.getSanctionInfoDesc();
        }
      });
    } else {
      this.matchResolutions = dropDownValues;
    }
  }

  getMatchStatus(matchId) {
    if (this.matchResolutions) {
      const match = this.matchResolutions.find(matchResolution => matchResolution.id === matchId);
      if (match) {
        return match.name;
      }
    }
    return 'Probable';
  }

  isPositiveResolution(matchId): boolean {
    const name = this.getMatchStatus(matchId);
    return /true/i.test(name);
  }

  // Open dialog having text editor to update Monitoring Elaboration text.
  openSanctionInfoUpdateDialog() {
    const config = new MdDialogConfig();
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(UpdateSanctionInfoComponent, config);
    this.dialogRef.componentInstance.argId = this.id;
    this.dialogRef.componentInstance.argEntityType = this.entityIdDetails.entityType;
    this.dialogRef.componentInstance.argSanctionDetailsData = this.sanctionInfoData;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      this.getSanctionInfoDesc();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/sanctioninfo/sanction-info.component.ts